export const GET_WEIGHT_RECO_DATA="GET_WEIGHT_RECO_DATA"
export const GET_WEIGHT_DATA="GET_WEIGHT_DATA"
export const GET_HOLD_DATA="GET_HOLD_DATA"
export const GET_SETTELED_DATA="GET_SETTELED_DATA"
export const GET_HISTORY_DATA="GET_HISTORY_DATA"
export const GET_ACCEPT_DATA="GET_ACCEPT_DATA"
export const GET_COMMENT_DATA="GET_COMMENT_DATA"
export const GET_DISPUTE_DATA="GET_DISPUTE_DATA"